module.exports = "<p>\r\n  logout-new works!\r\n</p>\r\n"